import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TTicketingUser } from '../types/ticketing-user.type';

export const SetAsAdminTicketingUserValidationSchema = z.object({
  userId: z.string({ message: 'User ID is required' }).min(1),
});

export type TSetAsAdminTicketingUserValidation = z.infer<typeof SetAsAdminTicketingUserValidationSchema>;
export type TSetAsAdminTicketingUserPayload = TSetAsAdminTicketingUserValidation;
export type TSetAsAdminTicketingUserResponse = ApiResponse<TTicketingUser>;

export const setAsAdminTicketingUser = async (
  payload: TSetAsAdminTicketingUserPayload
): Promise<TSetAsAdminTicketingUserResponse> => {
  const url = `/user-ticketing/manage/set-as-admin/${payload.userId}`;

  return axiosInstance.patch(url, payload);
};

/**
 * Use Set As Admin Ticketing User React-Query Hook
 */
type UseSetAsAdminTicketingUserMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof setAsAdminTicketingUser, AxiosErrorCustom>;
};

/**
 * Use Set As Admin Ticketing User React-Query Hook
 */
export const useSetAsAdminTicketingUserMutation = ({ mutationConfig }: UseSetAsAdminTicketingUserMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: setAsAdminTicketingUser,
    ...restConfig,
  });
};
